import React, { useContext, useEffect, useState } from 'react';
import { BlockLoading } from '../../../component/Loading';
import { useHistory } from 'react-router-dom';
import context from '../../context';
import apiService from 'apiService';

const Screen = ({ data, loading = false, loadingPcare = false }) => {
  const patient = useContext(context);
  const history = useHistory();
  const [refPayment, setrefPayment] = useState([])
  const [activePayments, setactivePayments] = useState(false)

  const {
    name,
    last_name,
    address,
    insurance_no,
    pcare_patient_code_provider,
    status_kepesertaan,
    payments,
    id_ihs
  } = data;

  const checkData = paramData => {
    if (Object.values(paramData).length) return true;
    else return false;
  };

  const register = paramData => {
    if (!checkData(paramData)) {
      return '';
    }

    patient.setData(paramData);
    history.push('/apm/clinic');
  };
  const getPayments = async () => {
    let res = await apiService.get('management/payment_types/read')
    if (res?.code === 200) {
      setrefPayment(res.data);
    }
  }
  useEffect(() => {
    getPayments()
  }, [refPayment.length])
  // useEffect(() => {
  //   console.log(data)
  // }, [data])
  return (
    <div>
      <div className='card rounded'>
        <BlockLoading loading={loading} />
        <BlockLoading loading={loadingPcare} text='Bridging Pcare..' />
        <div className='card-header'>
          <h2>DATA PASIEN</h2>
        </div>
        <div className='card-body'>
          <div className='row mb-3'>
            <div className='col-6'>
              <h2>NOMOR ASURANSI</h2>
            </div>
            <div className='col-6'>
              <h2
                className='text-wrap text-success'
                style={{ wordBreak: 'break-all' }}>
                {insurance_no}
              </h2>
            </div>
          </div>
          <div className='row my-3'>
            <div className='col-6'>
              <h2>ID SATU SEHAT</h2>
            </div>
            <div className='col-6'>
              <h2
                className='text-wrap text-success'
                style={{ wordBreak: 'break-all' }}>
                {id_ihs}
              </h2>
            </div>
          </div>
          <div className='row my-3'>
            <div className='col-6'>
              <h2>STATUS KEPESERTAAN</h2>
            </div>
            <div className='col-6'>
              <h2
                className='text-wrap text-success'
                style={{ wordBreak: 'break-all' }}>
                {status_kepesertaan}
              </h2>
            </div>
          </div>
          <div className='row my-3'>
            <div className='col-6'>
              <h2>NAMA PASIEN</h2>
            </div>
            <div className='col-6'>
              <h2
                className='text-wrap text-success'
                style={{ wordBreak: 'break-all' }}>
                {`${name || ''} ${last_name || ''}`}
              </h2>
            </div>
          </div>
          <div className='row my-3'>
            <div className='col-6'>
              <h2>ALAMAT PASIEN</h2>
            </div>
            <div className='col-6'>
              <h2
                className='text-wrap text-success'
                style={{ wordBreak: 'break-all' }}>
                {address}
              </h2>
            </div>
          </div>
          <div className='row my-3'>
            <div className='col-6'>
              <h2>PROVIDER PASIEN</h2>
            </div>
            <div className='col-6'>
              <h2
                className='text-wrap text-success'
                style={{ wordBreak: 'break-all' }}>
                {pcare_patient_code_provider}
              </h2>
            </div>
          </div>
          <div className='row my-3'>
            <div className='col-6'>
              <h2>Status Pembayaran Terakhir</h2>
            </div>
            <div className='col-6'>
              <h2
                className='text-wrap text-success'
                style={{ wordBreak: 'break-all' }}>
                {payments?.name}
              </h2>
            </div>
          </div>
          {activePayments ?
            <div className='row my-3'>
              <div className='col-6'>
                <h2>Status Pembayaran Saat ini</h2>
              </div>
              <div className='col-6'>
                <select className='form-control' value={payments?.id}>
                  <option>pilih</option>
                  {
                    refPayment.map((a, b) => {
                      return <option key={b} value={a.id}>{a.name}</option>
                    })
                  }
                </select>
              </div>
            </div>
            : ''}
          <div className='row mt-4'>
            <div className='col offset-4'>
              <button
                type='button'
                className={`${checkData(data) ? '' : 'd-none'}
 btn btn-success btn-icon` }
                onClick={() => register(data)}>
                <span className='btn-inner--icon'>
                  <i className='fas fa-sign-in-alt'></i>
                </span>
                <span className='btn-inner--text'>PILIH KLINIK</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Screen;
